import React from 'react';
import './index.scss';
import { Toast, Modal } from 'antd-mobile';
import * as PostService from '../../service/post';
import { AppUpgradeInfo } from '../../service/model';

const APP_ICON_URL = 'https://oss.gsteps.cn/allfile/admin/bbeb5679-fd85-4696-a4df-cc4ff5dc0207-1787726930381.png';

interface Props {}

interface State {
  loading: boolean;
  downloading: boolean;
  isWeiXin: boolean;
  upgradeInfo: AppUpgradeInfo | null;
}

export class AndroidAppDownload extends React.PureComponent<Props, State> {

  constructor(p: any) {
    super(p);
    this.state = {
      loading: true,
      downloading: false,
      isWeiXin: false,
      upgradeInfo: null,
    };
  }

  async componentDidMount(): Promise<void> {
    const ua = window.navigator.userAgent.toLowerCase();
    const isWeiXin = /MicroMessenger/i.test(ua);
    this.setState({ isWeiXin });

    const upgradeInfo = await PostService.getAndroidAppUpgrade();
    this.setState({
      loading: false,
      upgradeInfo,
    });
  }

  handleDownload = async () => {
    const { isWeiXin, upgradeInfo, downloading } = this.state;
    if (downloading) {
      return;
    }
    if (isWeiXin) {
      Modal.alert('提示', '微信内无法直接下载安装包，请点击右上角「···」，选择「在浏览器中打开」后再下载。', [
        { text: '我知道了', onPress: () => {} },
      ]);
      return;
    }

    let info = upgradeInfo;
    if (!info || !info.apk_url) {
      Toast.loading('获取下载地址...', 0);
      info = await PostService.getAndroidAppUpgrade();
      Toast.hide();
      if (!info || !info.apk_url) {
        Toast.fail('获取下载地址失败，请稍后重试');
        return;
      }
      this.setState({ upgradeInfo: info });
    }

    this.setState({ downloading: true });
    try {
      window.location.href = info.apk_url;
    } finally {
      setTimeout(() => {
        this.setState({ downloading: false });
      }, 1500);
    }
  };

  formatPublishTime(publishedAt: string): string {
    return publishedAt.replace('T', ' ').replace('+08:00', '');
  }

  renderVersion() {
    const { loading, upgradeInfo } = this.state;
    if (loading) {
      return <p className="version">加载中...</p>;
    }
    if (upgradeInfo && upgradeInfo.version_name) {
      return (
        <div className="version-block">
          <p className="app-name">G-STEPS（安卓客户端）</p>
          <p className="version">v{upgradeInfo.version_name}</p>
          {upgradeInfo.published_at ? (
            <p className="publish-time">发布时间：{this.formatPublishTime(upgradeInfo.published_at)}</p>
          ) : null}
        </div>
      );
    }
    return <p className="version error">获取版本失败</p>;
  }

  render() {
    const { loading, downloading } = this.state;

    return (
      <div className="android-app-download">
        <img className="app-icon" src={APP_ICON_URL} alt="G-STEPS" />
        {this.renderVersion()}
        <button
          className="download-btn"
          type="button"
          disabled={loading || downloading}
          onClick={this.handleDownload}
        >
          {downloading ? '下载中...' : '点击立即下载'}
        </button>
      </div>
    );
  }
}
